import React from 'react';
import Menu from '../../../components/Menu/Navbar'
import Header from '../../../components/Header/header'
import Logo from '../../../components/Logo/logo'
import Footer from '../../../components/Footer/footer'
import { ContainerGeneral, ElementoLista, Titulo, Lista, ContainerTexto, ContainerImagenes, Imagen } from '../../RioGrande/styletexto';
import FxView from '../../../components/FxView/fxview'
import FxImagenBackGround from '../../../components/FxImagenBackGround/fximagenbackground'

import { faCoffee } from '@fortawesome/free-solid-svg-icons';

const Actividades = () => {
  return (
    <div>
      <Menu />
      <Header />
      <Logo />
      <FxView />

      <FxImagenBackGround icon={faCoffee} /> {/* Usar el nuevo icono aquí */}



      <ContainerGeneral>
        <ContainerTexto>


          <Titulo>KIOSKO BAR </Titulo>


          <Lista>
            <ElementoLista>
            El Kiosko-Bar situado junto a las pistas de padel de nuestro Club, se encuentra abierto de lunes a domingo en el horario de apertura y cierre del Club, siendo este el siguiente: 
            </ElementoLista>
          </Lista>

          <Lista>
            <ElementoLista>
            - De lunes a viernes de 10:00 a 13:30h y de 17:30 a 23:00 horas 

            </ElementoLista>
          </Lista>

          <Lista>
            <ElementoLista>
           - Sábados y Domingos de 09:00 a 15:00 horas

            </ElementoLista>
          </Lista>


          <Lista>
            <ElementoLista>
            También informaros que para todos los eventos que se organizan en el Club, el Kiosko-Bar estará abierto a tiempo completo con su carta habitual, además dichos días se abre la barbacoa y arroces en el restaurante Club. 

            </ElementoLista>
          </Lista>



          <ContainerImagenes>
            <Imagen src={require('./kiosko.jpg')} alt="kiosko bar" />
          </ContainerImagenes>






        </ContainerTexto>
      </ContainerGeneral>

      <Footer />
      <></>
    </div>
  )
}

export default Actividades
